import {ChangeDetectionStrategy, Component} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {RouterLink} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {FormGroupComponent} from '../../../components/form-inputs/form-group/form-group.component';
import {FormErrorService} from '../../../services/form-error.service';
import {AuthenticationService} from '../../../services/api/authentication-service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-auth-forgot-password',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslatePipe,
    FormGroupComponent,
    RouterLink
  ],
  templateUrl: './forgot.component.html'
})
export class ForgotComponent {
  public form = new FormGroup({
    email: new FormControl<string>('', [Validators.required, Validators.email]),
  });

  public constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly toastrService: ToastrService,
    private readonly formErrorService: FormErrorService,
  ) {}

  public submit() {
    this.form.markAllAsTouched();
    this.form.markAllAsDirty();

    const email = this.form.controls.email.value;

    if (this.form.valid && email) {
      this.authenticationService.requestPasswordReset(email).subscribe({
        next: response => this.toastrService.success(response.message),
        error: response => this.formErrorService.mapErrorToForm(this.form, response),
      })
    }
  }
}
